module.exports = __webpack_public_path__ + "img/vd-valentines-day.44095f3b.svg";